// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"5f40f779","787":"d6c24977"}[chunkId] + ".chunk.js";
};